<template>
  <li
      v-if="filter.length"
      class="single-filter"
      @mouseover="setIsOpen(true)"
      @mouseleave="setIsOpen(false)"
  >
    <div class="single-filter__title">
      {{ title }}
      <div class="gd-searh__num" v-if="selectedCount">
        <span>{{ selectedCount }}</span>
      </div>
    </div>

    <transition name="slide-up-fade" mode="out-in">
      <div v-if="open" class="single-filter__list-wrap">
        <ul class="single-filter__list">
          <YearChoice
              v-if="title === Filter.YEAR"
              class="single-filter__list-item"
              v-for="choice in filter"
              :key="choice.value"
              :choice="choice"/>
          <AltitudeChoice
              v-else-if="title === Filter.ALTITUDE"
              class="single-filter__list-item"
              v-for="choice in filter"
              :key="choice.value"
              :choice="choice"
          />
          <MediaChoice
              v-else-if="title === Filter.MEDIA"
              class="single-filter__list-item"
              v-for="choice in filter"
              :key="choice.value"
              :choice="choice"
          />
          <SpecificChoice
              v-else-if="title === Filter.SPECIFIC"
              class="single-filter__list-item"
              v-for="choice in filter"
              :key="choice.value"
              :choice="choice"
          />
        </ul>
      </div>
    </transition>
  </li>
</template>

<script setup lang="ts">
import {Category, Filter} from "../../../utils/types.ts";
import {useFilter} from "../../../composables/filter.ts";
import YearChoice from "./YearChoice.vue";
import AltitudeChoice from "./AltitudeChoice.vue";
import MediaChoice from "./MediaChoice.vue";
import SpecificChoice from "./SpecificChoice.vue";

const {setIsOpen, open} = useFilter();

interface Props {
  title: Filter;
  filter: Category[];
  selectedCount: number;
}

defineProps<Props>();
</script>
